import React from "react";
import { useUiPack } from "@/hooks/useUiPack";
import POS from "@/pages/POS";
import SimplePOS from "@/pages/simple/SimplePOS";

/** Classic POS vs Simple touch POS by company ui_pack. */
export default function UiPackPos() {
  const { isSimple } = useUiPack();
  return isSimple ? <SimplePOS /> : <POS />;
}
